import { render } from "./LocationOverview.vue?vue&type=template&id=4d28a854&scoped=true"
import script from "./LocationOverview.vue?vue&type=script&lang=js"
export * from "./LocationOverview.vue?vue&type=script&lang=js"

import "./LocationOverview.vue?vue&type=style&index=0&id=4d28a854&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d28a854"]])

export default __exports__